<template>
    <div id="create-policy-exception-page" class="dashboard-view">
        <div class="container">
            <section class="content">
                <h1>Add Exception</h1>
                <PolicyExceptionForm @formSubmitted="createException" />
            </section>
        </div>
    </div>
</template>

<script>
import PolicyExceptionForm from '@/components/forms/PolicyExceptionForm.vue'

const endpoint = process.env.VUE_APP_API_BASE + '/policy-exceptions/create'
import axios from 'axios'

export default {
    name: 'PoliciesCreate',
    components: {
        PolicyExceptionForm
    },
    data: function () {
        return {}
    },
    methods: {
        createException(data) {
            axios.post(endpoint, data)
                .then(response => {
                    console.log(response)
                    alert('Exception created successfully')
                    this.$router.push('/policy-exceptions')
                })
                .catch(error => {
                    console.log(error.response)
                    if (error.response && error.response.data?.data) {
                        alert(error.response.data.data)
                    } else {
                        alert('Error occurred!')
                        console.log(error)
                    }
                })
        }
    }
}
</script>

<style lang="scss" scoped>
</style>
